import { Outlet } from 'react-router'
export const ReferralsPageLayout = () => {
  return <Outlet />
}
